"use strict";
import { useAccount } from "hooks/useAccount";
import { useProviderChainId } from "hooks/useProviderChainId";
import { useSwitchChain } from "hooks/useSwitchChain";
import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { Button } from "ui/src";
import { useEnabledChains } from "features/chains/hooks/useEnabledChains";
import { UniverseChainId } from "features/chains/types";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 32px;
  background: ${({ theme }) => theme.surface1};
`;
const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 48px;
  background: ${({ theme }) => theme.surface2};
  border-radius: 24px;
  border: 1px solid ${({ theme }) => theme.surface3};
  max-width: 480px;
  text-align: center;
`;
const Title = styled.h1`
  font-size: 28px;
  font-weight: 600;
  color: ${({ theme }) => theme.neutral1};
  margin: 0;
`;
const Description = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.neutral2};
  line-height: 1.5;
  margin: 0;
`;
const StyledButton = styled(Button)`
  padding: 12px 20px !important;
  min-height: 48px !important;
`;
export function ChainGate({ children }) {
  const location = useLocation();
  const account = useAccount();
  const { chainId, isDetecting } = useProviderChainId();
  const switchChain = useSwitchChain();
  const { isTestnetModeEnabled } = useEnabledChains();
  const targetChainId = isTestnetModeEnabled ? UniverseChainId.Sepolia : UniverseChainId.Mainnet;
  const targetChainName = isTestnetModeEnabled ? "BNB Smart Chain Testnet" : "BNB Smart Chain";
  const isWrongChain = account.isConnected && chainId !== targetChainId;
  const handleSwitchChain = useCallback(async () => {
    try {
      await switchChain(targetChainId);
    } catch (error) {
      console.error("Failed to switch chain:", error);
    }
  }, [switchChain, targetChainId]);
  if (location.pathname.startsWith("/bridge")) {
    return <>{children}</>;
  }
  if (isDetecting) {
    return null;
  }
  if (!isWrongChain) {
    return <>{children}</>;
  }
  return <Container>
      <Card>
        <Title>Wrong Network</Title>
        <Description>
          This application only works on BNB Smart Chain. Please switch your wallet to continue.
        </Description>
        <StyledButton
    variant="branded"
    size="large"
    onPress={handleSwitchChain}
  >
          <Button.Text>Switch to {targetChainName}</Button.Text>
        </StyledButton>
      </Card>
    </Container>;
}
